import X from '../x.js';

class XIcon extends X {
  static icons() {
    return {
      'arrow-forward': `
        <g><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" style="fill: currentColor;"></path></g>
      `,
      add: `
        <g><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path></g>
      `,
      reorder: `
        <g><path d="M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"></path></g>
      `,
      info: `
        <g><path d="M11 17h2v-6h-2v6zM11 9h2V7h-2v2z"></path></g>
      `,
      close: `
        <g><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></g>
      `,
      'mode-edit': `
        <g><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path></g>

      `
    };
  }

  static get properties() {
    return {
      name: {
        type: String
      },
      size: {
        type: Number
      }
    };
  }

  render(target) {
    target.innerHTML = `
      <style>
        :host {
          display: inline-flex;
          align-items: center;
        }

        svg {
          width: var(--size, 24px);
          height: var(--size, 24px);
        }
      </style>

      <svg
        id="svg"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
      </svg>
    `;
  }

  update(target, triggers) {
    if ('name' in triggers) {
      this.$.svg.innerHTML = this.constructor.icons()[this.name];
    }

    if ('size' in triggers) {
      this.style.setProperty('--size', `${this.size}px`);
    }
  }
}

customElements.define('x-icon', XIcon);
